import { gql } from '@apollo/client'

export default gql`
  mutation annotateAnswer($id: ID!, $notes: String) {
    annotateAnswer(id: $id, notes: $notes) {
      id
    }
  }
`
